export default "__VITE_ASSET__a06e64d6__"